<script>
  import dataBtns from "../../data/dataButtons.json";
  import { mapGetters } from "vuex/dist/vuex.common.js";

  export default {
    components: {
      ButtonsWrapper: () => import("./ButtonsWrapper.vue"),
      ChatGroupMonitor: () => import("@/components/chat/Chat.vue"),
    },
    data() {
      return {
        currentTime: new Date(),
        buttons: dataBtns,
      };
    },
    computed: {
      ...mapGetters(["screen"]),
      screenWidth() {
        return this.screen.width;
      },
      setCounterSlideDimensions() {
        const dimensions = [
          { minWidth: 768, value: 22 },
          { minWidth: 540, value: 20 },
          { minWidth: 0, value: 18 },
        ];

        return dimensions.find((d) => this.screenWidth >= d.minWidth).value;
      },
      setButtonVisibility() {
        return this.buttons.filter((button) => {
          const startDate = new Date(button.initialDate);
          const expDate = new Date(button.endDate);

          return startDate <= this.currentTime && expDate > this.currentTime;
        });
      },
      showChatGroups() {
        if (this.$userData.role === "monitor" && Array.isArray(this.$userData.platformType)) {
          return this.$userData.platformType.includes("private");
        }
        if (this.$userData.role === "superadmin") {
          return true;
        }
        if (this.$userData.polices && this.$userData.polices["see-monitors-conference"] && this.$userData.polices["see-monitors-conference"].payload) {
          return true;
        }
        return false;
      },
    },
    methods: {
      updateTimer() {
        this.timer = setInterval(() => {
          this.currentTime = new Date();
        }, 1000);
      },
    },
    mounted() {
      this.updateTimer();
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
  };
</script>

<template>
  <div class="buttonsContainer">
    <ButtonsWrapper v-for="button in setButtonVisibility" :button="button" :setCounterSlideDimensions="setCounterSlideDimensions" :currentTime="currentTime" :key="button._id" />
    <ChatGroupMonitor v-if="showChatGroups" />
  </div>
</template>

<style lang="scss">
  .buttonsContainer {
    @include Flex(column, flex-end, flex-end);
    gap: $space-16;
    position: fixed;
    bottom: 90px;
    right: $space-8;
    z-index: 11;
    @include tabletWidth() {
      right: $space-12;
      bottom: $space-16;
    }
  }
</style>
